<div class="page-wrap bim-wrap">
    <ion-header *ngIf="!utils.isPhone">
        <ion-toolbar [class.standalone]="!projectView">
            <ion-buttons slot="start" *ngIf="projectView">
                <ion-button fill="clear" (click)="onToggleSplitPaneMenu()">
                    <ion-icon name="menu-outline" slot="icon-only"></ion-icon>
                </ion-button>
            </ion-buttons>

            <ng-container *ngTemplateOutlet="planTitleOrSelect"></ng-container>
        </ion-toolbar>
    </ion-header>
    <div class="page-content dp-side-menu-container bim-container">
        <ion-card *ngIf="allMeasurements && allMeasurements.values.length > 0" class="measurement-container">
            <ion-card-header>
                <ion-card-title>{{ 'projects.plans.bim.measure.all-measuring' | translate }}</ion-card-title>
            </ion-card-header>
            <ion-card-content>
                <div *ngFor="let measurement of allMeasurements.values; let i = index" class="measurement-item">
                    {{ measurement }} {{ allMeasurements.unit }}
                    <div>
                        <button class="button-has-icon-only button-clear" (click)="removeMeasurement(allMeasurements.unit, i)">
                            <fa-icon icon="trash" slot="icon-only"></fa-icon>
                        </button>
                        <button class="button-has-icon-only button-clear" (click)="copyMeasurement(measurement)">
                            <fa-icon icon="copy" slot="icon-only"></fa-icon>
                        </button>
                    </div>
                </div>
                <hr />
                <div class="measurement-sum">
                    {{ 'projects.plans.bim.measure.sum' | translate }} {{ allMeasurements.sum }} {{ allMeasurements.unit }}
                </div>
            </ion-card-content>
        </ion-card>
        <ion-grid class="dp-g-fab h-end fixed dp-edge" [ngClass]="utils.isPhone ? 'bottom' : 'top'">
            <ion-row
                *ngIf="
                    (!addingNewItem && projectView) ||
                        (!addingNewMarkerToJob && allowMultipleMarker) ||
                        (utils.mobileViewActive && !addingNewItem && !addingNewMarkerToJob) ||
                        (!utils.mobileViewActive && !addingNewMarkerToJob && !projectView) ||
                        (utils.isPhone && !allowMultipleMarker && !projectView);
                    else cancelFabBtns
                "
            >
                <ion-col
                    *ngIf="
                        (settingsSrv.currentUserRights.canManageProjects && projectView) ||
                        (!viewOnly && projectView && settingsSrv.currentUserRights.canManageProjects)
                    "
                >
                    <ion-button
                        class="dp-g-fab-btn"
                        shape="round"
                        color="danger"
                        size="small"
                        dpTooltip
                        [tooltipContent]="!viewOnly ? ('projects.plans.fabs.delete-bp' | translate) : undefined"
                        [tooltipTrigger]="!viewOnly ? 'mouseenter focus' : 'manual'"
                        tooltipPosition="bottom"
                        (click)="onDestructiveBtn()"
                    >
                        <fa-icon icon="trash" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
                <ion-col *ngIf="projectView && settingsSrv.currentUserRights.canManageProjects && !utils.isPhone">
                    <ion-button
                        class="dp-g-fab-btn"
                        shape="round"
                        color="primary"
                        size="small"
                        (click)="exportMarkers()"
                        dpTooltip
                        [tooltipContent]="!viewOnly ? ('projects.plans.fabs.export-markers' | translate) : undefined"
                        tooltipPosition="bottom"
                    >
                        <ion-spinner color="light" slot="icon-only" *ngIf="runningExport"></ion-spinner>
                        <fa-icon [icon]="['fal', 'arrow-down-from-dotted-line']" slot="icon-only" *ngIf="!runningExport"></fa-icon>
                    </ion-button>
                </ion-col>
                <ion-col *ngIf="!projectView && !viewOnly && !subView">
                    <ion-button
                        class="dp-g-fab-btn"
                        shape="round"
                        color="danger"
                        size="small"
                        dpTooltip
                        [tooltipContent]="'projects.plans.fabs.delete-marker' | translate"
                        tooltipPosition="bottom"
                        (click)="onDestructiveBtn()"
                    >
                        <fa-icon icon="trash" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
                <ion-col *ngIf="!projectView && !viewOnly && job">
                    <ion-button
                        class="dp-g-fab-btn"
                        shape="round"
                        color="primary"
                        size="small"
                        dpTooltip
                        [tooltipContent]="'projects.plans.fabs.add-marker' | translate"
                        tooltipPosition="bottom"
                        (click)="toggleJobMarkerMode()"
                    >
                        <fa-icon icon="plus" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
                <ion-col *ngIf="projectView && (settingsSrv.currentUserRights.canManageProjects || !viewOnly)">
                    <ion-button
                        class="dp-g-fab-btn"
                        shape="round"
                        color="primary"
                        size="small"
                        dpTooltip
                        [tooltipContent]="'projects.plans.fabs.add-marker' | translate"
                        tooltipPosition="bottom"
                        (click)="toggleMarkerMode()"
                    >
                        <fa-icon icon="plus" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
                <ion-col *ngIf="asDialog">
                    <ion-button
                        class="dp-g-fab-btn"
                        shape="round"
                        color="light"
                        dpTooltip
                        [tooltipContent]="'projects.plans.fabs.close' | translate"
                        tooltipPosition="bottom"
                        (click)="onCancelBtn()"
                    >
                        <fa-icon icon="times" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
                <ion-col *ngIf="!viewOnly && !asDialog">
                    <ion-button class="dp-g-fab-btn job-save-action" shape="round" color="success" (click)="onSaveBIMPlan()">
                        <fa-icon icon="check" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
            </ion-row>
            <ng-template #cancelFabBtns>
                <ion-row>
                    <ion-col>
                        <ion-button
                            class="dp-g-fab-btn"
                            shape="round"
                            color="danger"
                            (click)="addingNewMarkerToJob ? toggleJobMarkerMode() : toggleMarkerMode()"
                        >
                            <fa-icon icon="times" slot="icon-only"></fa-icon>
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ng-template>
        </ion-grid>
    </div>
    <div style="flex: 1; display: flex; min-height: 0; position: relative">
        <div class="bim-loading-overlay" *ngIf="loading">
            <app-loading-indicator>
                {{ 'projects.plans.bim.loading-plan' | translate }}
            </app-loading-indicator>
        </div>
        <div class="bim-loading-overlay" *ngIf="!loading && planPreparing">
            <app-loading-indicator>
                {{ 'projects.plans.bim.loading-plan' | translate }}
            </app-loading-indicator>
        </div>
        <div class="bim-loading-overlay" *ngIf="!loading && planFailed">
            <span>{{ 'projects.plans.errors.load-error' | translate }}</span>
        </div>
        <ion-grid class="dp-g-fab bim-plan-controls" *ngIf="!loading && !planPreparing && !planFailed">
            <ion-row>
                <ion-col
                    *ngIf="
                        (settingsSrv.currentUserRights.canManageProjects && projectView) ||
                        (!viewOnly && projectView && settingsSrv.currentUserRights.canManageProjects)
                    "
                >
                    <ion-button
                        class="dp-g-fab-btn"
                        shape="round"
                        color="light"
                        size="small"
                        (click)="openPopover('import', $event)"
                        dpTooltip
                        [tooltipContent]="!viewOnly ? ('projects.plans.fabs.generate-jobs-based-on-ifc-types' | translate) : undefined"
                        tooltipPosition="bottom"
                    >
                        <fa-icon icon="arrow-down-from-bracket" slot="icon-only"></fa-icon>
                    </ion-button>

                    <ion-popover
                        [isOpen]="activePopover === 'import'"
                        (didDismiss)="activePopover = null"
                        size="auto"
                        [showBackdrop]="false"
                        side="bottom"
                        alignment="center"
                        [event]="activePopoverEvent"
                    >
                        <ng-template>
                            <ion-content class="ion-padding">
                                <div class="ifc-type-title">{{ 'projects.plans.fabs.generate-jobs-based-on-ifc-types' | translate }}</div>
                                <ng-select
                                    [items]="ifcTypes"
                                    bindLabel="name"
                                    bindValue="name"
                                    [(ngModel)]="selectedImportType"
                                    [clearable]="true"
                                    [placeholder]="'projects.plans.bim.choose-ifc-type' | translate"
                                    (ngModelChange)="onImportTypeChange($event)"
                                    appendTo="body"
                                ></ng-select>
                                <ng-select
                                    [items]="projectServiceGroups"
                                    bindLabel="name"
                                    [(ngModel)]="selectedImportServiceGroup"
                                    [clearable]="true"
                                    [placeholder]="'projects.plans.bim.choose-sg' | translate"
                                    appendTo="body"
                                    style="margin-top: 8px"
                                ></ng-select>
                                <div
                                    *ngIf="selectedImportType && importElementCount > 0"
                                    style="margin-top: 8px; font-size: 13px; opacity: 0.8"
                                >
                                    {{ importElementCount }} {{ 'projects.plans.bim.amount-to-import' | translate }}
                                </div>
                                <ion-button
                                    expand="block"
                                    style="margin-top: 12px"
                                    [disabled]="
                                        !selectedImportType || !selectedImportServiceGroup || generatingJobs || importElementCount === 0
                                    "
                                    (click)="generateJobs()"
                                >
                                    <ion-spinner *ngIf="generatingJobs" name="crescent" slot="start"></ion-spinner>
                                    @if (generatingJobs) {
                                        {{ 'projects.plans.bim.creating-jobs' | translate }}
                                    } @else {
                                        {{ 'projects.plans.bim.create-jobs' | translate }}
                                    }
                                </ion-button>
                            </ion-content>
                        </ng-template>
                    </ion-popover>
                </ion-col>
                <ion-col *ngIf="modelLoaded && projectView">
                    <ion-button
                        class="dp-g-fab-btn"
                        shape="round"
                        [color]="measurementMode !== 'none' ? 'warning' : 'light'"
                        size="small"
                        (click)="openPopover('measurement', $event)"
                        dpTooltip
                        [tooltipContent]="'projects.plans.fabs.measure-tape' | translate"
                        tooltipPosition="bottom"
                    >
                        <fa-icon icon="ruler" slot="icon-only"></fa-icon>
                    </ion-button>

                    <ion-popover
                        [isOpen]="activePopover === 'measurement'"
                        (didDismiss)="activePopover = null"
                        size="auto"
                        [showBackdrop]="false"
                        side="bottom"
                        alignment="center"
                        [event]="activePopoverEvent"
                    >
                        <ng-template>
                            <ion-content class="ion-padding">
                                <div class="ifc-type-title">{{ 'projects.plans.fabs.measure-tape' | translate }}</div>

                                <ion-item
                                    button
                                    (click)="toggleLengthMeasurement(); activePopover = null"
                                    [color]="measurementMode === 'length' ? 'warning' : ''"
                                    *ngIf="!utils.isPhone"
                                >
                                    <fa-icon icon="ruler-horizontal" class="dp-mr-s"></fa-icon>
                                    <ion-label>
                                        <div>{{ 'projects.plans.bim.measure.length-title' | translate }}</div>
                                        <div style="font-size: 12px; opacity: 0.7">
                                            {{ 'projects.plans.bim.measure.length-desc' | translate }}
                                        </div>
                                    </ion-label>
                                </ion-item>

                                <ion-item
                                    button
                                    (click)="toggleAreaMeasurement(); activePopover = null"
                                    [color]="measurementMode === 'area' ? 'warning' : ''"
                                >
                                    <fa-icon icon="ruler-combined" class="dp-mr-s"></fa-icon>
                                    <ion-label>
                                        <div>{{ 'projects.plans.bim.measure.area-title' | translate }}</div>
                                        <div style="font-size: 12px; opacity: 0.7">
                                            {{ 'projects.plans.bim.measure.area-desc' | translate }}
                                        </div>
                                    </ion-label>
                                </ion-item>

                                <ion-item *ngIf="measurementMode !== 'none'" lines="none">
                                    <ion-button
                                        expand="block"
                                        color="danger"
                                        fill="clear"
                                        (click)="
                                            measurementMode === 'length' ? toggleLengthMeasurement() : toggleAreaMeasurement();
                                            activePopover = null;
                                            allMeasurements = null
                                        "
                                    >
                                        <fa-icon icon="times" slot="start"></fa-icon>
                                        {{ 'projects.plans.bim.measure.stop' | translate }}
                                    </ion-button>
                                </ion-item>
                            </ion-content>
                        </ng-template>
                    </ion-popover>
                </ion-col>
                <ion-col
                    *ngIf="
                        (ifcTypes.length > 0 && settingsSrv.currentUserRights.canManageProjects && projectView) ||
                        (!viewOnly && projectView && settingsSrv.currentUserRights.canManageProjects)
                    "
                >
                    <ion-button
                        class="dp-g-fab-btn"
                        shape="round"
                        color="light"
                        size="small"
                        (click)="openPopover('objectTypes', $event)"
                        dpTooltip
                        [tooltipContent]="!viewOnly ? ('projects.plans.fabs.hide-ifc-types' | translate) : undefined"
                        tooltipPosition="bottom"
                    >
                        <fa-icon icon="eye" slot="icon-only"></fa-icon>
                    </ion-button>

                    <ion-popover
                        [isOpen]="activePopover === 'objectTypes'"
                        (didDismiss)="activePopover = null"
                        size="auto"
                        [showBackdrop]="false"
                        side="bottom"
                        alignment="center"
                        [event]="activePopoverEvent"
                    >
                        <ng-template>
                            <ion-content class="ion-padding">
                                <div class="ifc-type-title">{{ 'projects.plans.bim.ifc-object-types' | translate }}</div>
                                <div *ngFor="let type of ifcTypes" class="ifc-type-row" (click)="onToggleIfcType(type)">
                                    <ion-checkbox [checked]="type.visible"></ion-checkbox>
                                    <span [class.hidden-type]="!type.visible">{{ type.name }}</span>
                                </div>
                            </ion-content>
                        </ng-template>
                    </ion-popover>
                </ion-col>
                <ion-col>
                    <ion-button
                        class="dp-g-fab-btn"
                        shape="round"
                        color="light"
                        size="small"
                        (click)="fitModel()"
                        dpTooltip
                        [tooltipContent]="'projects.plans.fabs.fit-model' | translate"
                        tooltipPosition="bottom"
                    >
                        <fa-icon icon="compress" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
        <!-- Mobile navigation controls -->
        <ion-grid class="dp-g-fab bim-nav-controls" *ngIf="utils.isPhone && modelLoaded && !loading">
            <ion-row class="ion-justify-content-center">
                <ion-col size="auto">
                    <ion-button class="bim-nav-btn" fill="clear" color="dark" size="small" (click)="moveCamera('up')">
                        <fa-icon icon="chevron-up" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
            </ion-row>
            <ion-row class="ion-justify-content-center">
                <ion-col size="auto">
                    <ion-button class="bim-nav-btn" fill="clear" color="dark" (click)="moveCamera('left')">
                        <fa-icon icon="chevron-left" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
                <ion-col size="auto" class="ion-display-flex zoom-controls">
                    <ion-button class="bim-nav-btn bim-zoom-btn dp-g-fab-btn" fill="solid" color="light" (click)="zoomModel('in')">
                        <fa-icon icon="magnifying-glass-plus" slot="icon-only"></fa-icon>
                    </ion-button>
                    <ion-button class="bim-nav-btn bim-zoom-btn" fill="solid" color="light" (click)="zoomModel('out')">
                        <fa-icon icon="magnifying-glass-minus" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
                <ion-col size="auto">
                    <ion-button class="bim-nav-btn" fill="clear" color="dark" (click)="moveCamera('right')">
                        <fa-icon icon="chevron-right" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
            </ion-row>
            <ion-row class="ion-justify-content-center">
                <ion-col size="auto">
                    <ion-button class="bim-nav-btn" fill="clear" color="dark" (click)="moveCamera('down')">
                        <fa-icon icon="chevron-down" slot="icon-only"></fa-icon>
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div #container style="flex: 1; position: relative"></div>
        <div *ngIf="popupVisible && displayJob" class="popup-wrap" [style.left.px]="popupX" [style.top.px]="popupY">
            <app-map-popup
                [job]="displayJob"
                [jobMarkerId]="displayMarkerId || displayJob.marker?.[0]?._id"
                [serviceGroup]="displayServiceGroup"
                [changesAllowed]="!viewOnly && (projectView ? settingsSrv.currentUserRights.canManageProjects : true)"
                [linkDetails]="projectView"
                (onClose)="popupVisible = false"
                (onDelete)="onRemoveMarker(); popupVisible = false"
                (onDetails)="onOpenJobDetails($event.serviceGroup)"
                (jobChange)="onJobMarkerChanged($event)"
            ></app-map-popup>
        </div>
    </div>

    <ion-footer *ngIf="utils.isPhone">
        <ion-toolbar class="standalone">
            <ng-container *ngTemplateOutlet="planTitleOrSelect"></ng-container>
        </ion-toolbar>
    </ion-footer>
</div>

<ng-template #planTitleOrSelect>
    <ng-container *ngIf="projectView && !viewOnly && settingsSrv.currentUserRights.canManageProjects; else planNameNotEditable">
        <ion-chip color="white" outline="true" (click)="onReplacePlanName()">
            <fa-icon icon="pencil"></fa-icon>
            <ng-container *ngTemplateOutlet="planNameLabel"></ng-container>
        </ion-chip>
    </ng-container>

    <ng-template #planNameNotEditable>
        <ng-container *ngIf="viewOnly || (projectView && !settingsSrv.currentUserRights.canManageProjects); else planNameSelect">
            <ng-container *ngTemplateOutlet="planNameLabel"></ng-container>
        </ng-container>
    </ng-template>

    <ng-template #planNameSelect>
        <ng-container *ngIf="!utils.isPhone">
            <ng-select
                [items]="buildingPlanList || []"
                bindLabel="name"
                bindValue="_id"
                [ngModel]="buildingPlan?._id"
                dropdownPosition="auto"
                [clearable]="false"
                [placeholder]="'projects.plans.select-plan' | translate"
                appendTo="body"
                [searchable]="false"
                (ngModelChange)="onPlanSelectChange($event)"
                *ngIf="buildingPlanList; else planNameLabel"
                groupBy="group"
            >
            </ng-select>
        </ng-container>

        <ng-container *ngIf="utils.isPhone">
            <ion-item class="mobile-plan-select-btn" button color="white" detail="false" lines="none" (click)="selectDrawer.toggleDrawer()">
                <fa-icon slot="start" icon="chevron-down"></fa-icon>
                <ion-label>{{ buildingPlan != undefined ? buildingPlan.name : ('shared.select' | translate) }}</ion-label>
            </ion-item>
        </ng-container>
    </ng-template>

    <ng-template #planNameLabel>
        <ion-label>{{ buildingPlan?.name }}</ion-label>
    </ng-template>
</ng-template>

<app-dp-backdrop [show]="showBackdrop" (onTap)="selectDrawer.toggleDrawer()"></app-dp-backdrop>

<app-select-drawer
    style="position: absolute"
    appendTo="ion-app"
    [allowEmpty]="true"
    [value]="buildingPlan?._id"
    [items]="buildingPlanList"
    [groupItems]="true"
    (openStateChanged)="toggleBackdrop($event)"
    (onChange)="onPlanSelectChange($any($event)?._id)"
    #selectDrawer
></app-select-drawer>
